export const Logo = ({ className = "", light = false }) => {
  const bg = light ? "#ffffff" : "#0B1F3A";
  const fg = light ? "#0B1F3A" : "#ffffff";
  return (
    <svg viewBox="0 0 48 48" className={className} role="img" aria-label="TIRERA GROUP">
      <rect x="1.5" y="1.5" width="45" height="45" rx="11" fill={bg} />
      <rect x="1.5" y="1.5" width="45" height="45" rx="11" fill="none" stroke={fg} strokeOpacity="0.15" strokeWidth="1" />
      <text
        x="50%"
        y="53%"
        dominantBaseline="middle"
        textAnchor="middle"
        fontFamily="General Sans, sans-serif"
        fontWeight="700"
        fontSize="19"
        letterSpacing="-1"
        fill={fg}
      >
        TG
      </text>
    </svg>
  );
};

export default Logo;
